import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import './i18n';
import './index.css';
import { queryClient } from './lib/query';
import { AuthProvider } from './providers/auth';
import { LocaleProvider } from './providers/locale';
import { ThemeProvider } from './providers/theme';
import { ToastProvider } from './providers/toast';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <LocaleProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <AuthProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </AuthProvider>
          </ToastProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </LocaleProvider>
  </StrictMode>,
);
